module.exports = __webpack_public_path__ + "static/media/repost.ea562491.svg";